document.addEventListener('DOMContentLoaded', () => {
  const normalize = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();
  const savedKey = 'tfhSavedFindsV1';
  const recentKey = 'tfhRecentlyViewedV1';
  const readList = (key) => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  };
  const writeList = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };
  const productData = new Map();
  document.querySelectorAll('[data-tfh-product-data]').forEach((node) => {
    try {
      const item = JSON.parse(node.textContent);
      productData.set(String(item.id), item);
    } catch (_) {}
  });

  const updateSavedUI = () => {
    const saved = readList(savedKey);
    const ids = new Set(saved.map((item) => String(item.id)));
    document.querySelectorAll('[data-tfh-save-find]').forEach((button) => {
      const active = ids.has(String(button.dataset.productId));
      button.classList.toggle('is-saved', active);
      button.setAttribute('aria-pressed', String(active));
      const label = button.querySelector('[data-tfh-save-label]');
      if (label && button.classList.contains('tfh-save-find--product')) {
        label.textContent = active ? 'Saved to My Finds' : 'Save This Find';
      }
    });
    document.querySelectorAll('[data-tfh-finds-count]').forEach((count) => {
      count.textContent = saved.length;
      count.hidden = saved.length === 0;
    });
  };

  const toggleSaved = (button) => {
    const id = String(button.dataset.productId);
    const saved = readList(savedKey);
    const index = saved.findIndex((item) => String(item.id) === id);
    if (index >= 0) {
      saved.splice(index, 1);
    } else {
      const item = productData.get(id);
      if (item) saved.unshift({ ...item, savedAt: Date.now() });
    }
    writeList(savedKey, saved);
    updateSavedUI();
    renderClientShelves();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tfh-save-find]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    toggleSaved(button);
  });

  const clientCard = (item) => {
    productData.set(String(item.id), item);
    const sold = item.available === false;
    return `
      <article class="tfh-client-card">
        <a class="tfh-client-card__media" href="${item.url}">
          ${item.image ? `<img src="${item.image}" alt="" loading="lazy">` : ''}
          ${sold ? '<span class="tfh-client-card__sold">SOLD</span>' : ''}
        </a>
        <div class="tfh-client-card__body">
          <h3><a href="${item.url}">${item.title}</a></h3>
          <p>${item.price}</p>
          ${sold ? '<p class="tfh-client-card__note">Open this find and ask us to help find another.</p>' : ''}
          <div class="tfh-client-card__actions">
            <a class="button button--secondary" href="${item.url}">${sold ? 'Help Me Find One' : 'View Find'}</a>
            <button type="button" class="tfh-save-find is-saved" data-tfh-save-find data-product-id="${item.id}" aria-pressed="true" aria-label="Remove ${item.title} from My Finds">
              <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21.3l7.8-7.8 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg>
              <span class="visually-hidden">Remove from My Finds</span>
            </button>
          </div>
        </div>
      </article>`;
  };

  function renderClientShelves() {
    document.querySelectorAll('[data-tfh-my-finds]').forEach((section) => {
      const items = readList(savedKey);
      const grid = section.querySelector('[data-tfh-client-grid]');
      const empty = section.querySelector('[data-tfh-empty]');
      if (grid) grid.innerHTML = items.map(clientCard).join('');
      if (empty) empty.hidden = items.length > 0;
    });

    document.querySelectorAll('[data-tfh-recently-viewed]').forEach((section) => {
      const currentId = document.querySelector('product-info')?.dataset.productId;
      const limit = Number(section.dataset.limit || 4);
      const items = readList(recentKey).filter((item) => String(item.id) !== String(currentId)).slice(0, limit);
      const grid = section.querySelector('[data-tfh-client-grid]');
      if (grid) grid.innerHTML = items.map(clientCard).join('');
      section.hidden = items.length === 0;
    });
    updateSavedUI();
  }

  const currentProduct = document.querySelector('product-info')?.dataset.productId;
  if (currentProduct && productData.has(String(currentProduct))) {
    const recent = readList(recentKey).filter((item) => String(item.id) !== String(currentProduct));
    recent.unshift({ ...productData.get(String(currentProduct)), viewedAt: Date.now() });
    writeList(recentKey, recent.slice(0, 12));
  }
  renderClientShelves();

  const departmentBrowser = document.querySelector('[data-tfh-department-browser]');
  if (departmentBrowser) {
    const mobile = window.matchMedia('(max-width: 989px)').matches;
    if (!mobile) departmentBrowser.open = true;
    if (mobile && window.location.hash === '#ProductGridContainer') {
      departmentBrowser.open = false;
      const showProducts = () => {
        departmentBrowser.open = false;
        document.querySelector('#ProductGridContainer')?.scrollIntoView({ behavior: 'auto', block: 'start' });
      };
      window.requestAnimationFrame(() => window.requestAnimationFrame(showProducts));
      window.setTimeout(showProducts, 180);
      window.addEventListener('load', showProducts, { once: true });
    }
  }

  const footerSocials = document.querySelector('.tfh-footer__social .list-social');
  const headerIcons = document.querySelector('.header__icons');
  if (footerSocials && headerIcons && !headerIcons.querySelector('.tfh-header-socials')) {
    const headerSocials = footerSocials.cloneNode(true);
    headerSocials.classList.add('tfh-header-socials', 'small-hide', 'medium-hide');
    headerSocials.setAttribute('aria-label', 'Follow Thrift From Home');
    headerIcons.appendChild(headerSocials);
  }

  document.querySelectorAll('.tfh-find-request__close').forEach((button) => {
    button.addEventListener('click', () => {
      button.closest('.tfh-find-request__details')?.removeAttribute('open');
    });
  });

  document.querySelectorAll('.tfh-find-request__form').forEach((form) => {
    const email = form.querySelector('[data-tfh-contact-email]');
    const phone = form.querySelector('[data-tfh-contact-phone]');
    const error = form.querySelector('[data-tfh-contact-error]');

    const clearContactError = () => {
      if (email?.value.trim() || phone?.value.trim()) {
        error.hidden = true;
        email?.removeAttribute('aria-invalid');
        phone?.removeAttribute('aria-invalid');
      }
    };

    email?.addEventListener('input', clearContactError);
    phone?.addEventListener('input', clearContactError);

    form.addEventListener('submit', (event) => {
      if (!email?.value.trim() && !phone?.value.trim()) {
        event.preventDefault();
        error.hidden = false;
        email?.setAttribute('aria-invalid', 'true');
        phone?.setAttribute('aria-invalid', 'true');
        email?.focus();
        return;
      }

      // Shopify's native contact form expects an email-shaped reply address.
      // Preserve phone-only requests with a non-marketing internal placeholder.
      if (!email.value.trim() && phone?.value.trim()) {
        email.value = 'phone-request@thriftfromhome.com';
      }
    });
  });

  document.querySelectorAll('[data-tfh-scratch-section]').forEach((section) => {
    const cards = [...section.querySelectorAll('[data-tfh-scratch-card]')];
    const actions = section.querySelector('[data-tfh-sale-actions]');
    const storageKey = `tfh-color-sale-${section.dataset.weekKey || 'current'}`;

    const updateActions = () => {
      if (actions && cards.every((card) => card.classList.contains('is-revealed'))) {
        actions.hidden = false;
      }
    };

    const celebrate = (card) => {
      const colors = ['#2FB7B1', '#FF6B4A', '#0F1F2E', '#FFD23F', '#3A86FF', '#42D93D'];
      for (let index = 0; index < 28; index += 1) {
        const particle = document.createElement('i');
        particle.className = 'tfh-confetti';
        particle.style.setProperty('--x', `${Math.random() * 240 - 120}px`);
        particle.style.setProperty('--r', `${Math.random() * 720 - 360}deg`);
        particle.style.setProperty('--delay', `${Math.random() * 0.18}s`);
        particle.style.background = colors[index % colors.length];
        card.appendChild(particle);
        window.setTimeout(() => particle.remove(), 1700);
      }
    };

    const reveal = (card, withConfetti = true) => {
      if (card.classList.contains('is-revealed')) return;
      card.classList.add('is-revealed');
      card.querySelector('[data-tfh-scratch-cover]')?.setAttribute('aria-expanded', 'true');
      if (withConfetti) celebrate(card);
      updateActions();
      try {
        localStorage.setItem(storageKey, 'revealed');
      } catch (_) {}
    };

    cards.forEach((card) => {
      const cover = card.querySelector('[data-tfh-scratch-cover]');
      if (!cover) return;

      cover.addEventListener('click', () => reveal(card));
      cover.addEventListener('pointerdown', () => reveal(card));
      cover.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          reveal(card);
        }
      });
    });

    try {
      if (localStorage.getItem(storageKey) === 'revealed') {
        cards.forEach((card) => reveal(card, false));
      }
    } catch (_) {}
  });

  document.querySelectorAll('[data-tfh-open-departments]').forEach((button) => {
    button.addEventListener('click', () => {
      const browser = document.querySelector('[data-tfh-department-browser]');
      if (!browser) return;
      browser.open = true;
      browser.classList.add('is-drawer-open');
      document.body.classList.add('tfh-department-drawer-open');
      browser.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-tfh-department-browser]').forEach((browser) => {
    browser.addEventListener('toggle', () => {
      if (browser.open) return;
      browser.classList.remove('is-drawer-open');
      document.body.classList.remove('tfh-department-drawer-open');
    });
  });
});
